import { dashboardActionTypes } from '../actionTypes'

let types = dashboardActionTypes

const state = {
    timeRange: '1day'
}

const mutations = {
    [types.TIME_RANGE]: (state, value) => {
        state.timeRange = value
    }
}

const actions = {
    [types.TIME_RANGE] ({ commit }, payload) {
        commit(types.TIME_RANGE, payload)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
